import {mergeAll} from 'ramda';

import {DmsDataGrid} from '@dms/shared';

import {RequiredTestIdProps} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

const SERVICE_ACCOUNT_AUDIT_LOG_GRID_CODE = 'service-account-audit-log';

interface ServiceAccountAuditLogTabProps extends RequiredTestIdProps {
  serviceAccountId: string;
}

export function ServiceAccountAuditLogTab(props: ServiceAccountAuditLogTabProps) {
  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([filter, {serviceAccountId: props.serviceAccountId}]);

  return (
    <DmsDataGrid
      gridCode={SERVICE_ACCOUNT_AUDIT_LOG_GRID_CODE}
      autoHeight
      queryModifier={queryModifier}
      data-testid={props['data-testid']}
    />
  );
}
